(function () {
  // Loaded from a theme asset so Usercentrics' autoblocker does not match
  // the old inline-script hash and hold this until Accept. That delay meant
  // UC_CONSENT fired before this listener existed, so setTrackingConsent
  // never ran. The listener is still attached before loadFeatures resolves,
  // because Accept can unblock consent-tracking-api and fire UC_CONSENT
  // before that callback.
  let pendingConsent = null
  let customerPrivacyReady = false

  const syncTrackingConsent = consentObj => {
    window.Shopify.customerPrivacy.setTrackingConsent(consentObj, () => {
      console.log("** UC consent synced with Shopify Customer Privacy API")
      console.log("- Shopify consent:")
      console.log(window.Shopify.customerPrivacy.currentVisitorConsent())
      console.log("--------------------------")
    })
  }

  window.addEventListener("UC_CONSENT", e => {
    const services = Object.values(e.detail.services)
    const ucAnalytics = services.find(service => service.name == 'Shopify Analytics')
    const ucMarketing = services.find(service => service.name == 'Shopify Marketing')
    const ucPreferences = services.find(service => service.name == 'Shopify Preferences')
    if (!ucAnalytics || !ucMarketing || !ucPreferences) {
      console.warn('No DPSs found (Shopify Analytics, Shopify Marketing, Shopify Preferences)')
      return
    }

    const analyticsConsent = ucAnalytics.consent.given
    const marketingConsent = ucMarketing.consent.given
    const preferencesConsent = ucPreferences.consent.given
    console.log('** Usercentrics consent:')
    console.log("- status: " + e.detail.consent.status)
    console.log("- updatedBy: " + e.detail.consent.updatedBy)
    console.log("- Analytics: " + analyticsConsent)
    console.log("- Marketing: " + marketingConsent)
    console.log("- Preferences: " + preferencesConsent)

    let consentObj
    if (customerPrivacyReady && window.Shopify.customerPrivacy.saleOfDataRegion()) {
      const val = e.detail.consent.status == 'ALL_DENIED' ? false : true
      console.log("** is using Opt-Out framework: true")
      consentObj = { analytics: val, marketing: val, preferences: val, sale_of_data: val }
    } else {
      consentObj = { analytics: analyticsConsent, marketing: marketingConsent, preferences: preferencesConsent }
    }

    if (customerPrivacyReady) {
      syncTrackingConsent(consentObj)
    } else {
      pendingConsent = consentObj
    }
  })

  window.Shopify.loadFeatures(
    [{ name: 'consent-tracking-api', version: '0.1' }],
    error => {
      if (error) throw error
      console.log('** Shopify Consent Tracking API loaded')
      customerPrivacyReady = true
      if (pendingConsent) {
        syncTrackingConsent(pendingConsent)
        pendingConsent = null
      }
    }
  )
})()
